/* eslint-disable no-unused-lets */
import 'es6-promise/auto';
import Vue from "vue";
// import SearchPage from "./pages/SearchPage";
import SearchPage from "./pages/SearchPage";
import ResourcePage from "./pages/ResourcePage";
import AdvanceSearch from "./components/AdvanceSearch";
import GuidedSearch from "./components/GuidedSearch";
import GuidedSearchBlock from "./components/GuidedSearchBlock";
import GlobalSearchForm from "./components/GlobalSearchForm";
import VueRouter from 'vue-router'

Vue.use(VueRouter)
Vue.component('AdvanceSearch', AdvanceSearch);
Vue.component('GuidedSearch', GuidedSearch);
Vue.component('GuidedSearchBlock', GuidedSearchBlock);

import store from './store'

const routes = [
    { path: '/:language/resources', component: SearchPage },
    { path: '/resources', component: SearchPage },
    { path: '/:language/resources/show/:urlsegment', component: ResourcePage, name: 'ResourcePage' },
]

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
});

/* eslint-disable no-new */
new Vue({
    router,
    store,
    el: "#app",
    components: {
        GlobalSearchForm
    },
    computed: {
        selectedResources() {
            return this.$store.state.selectedResources;
        }
    },
    mounted() {
        console.info("main app....");

        loadjQueryPlugins();
    },
    updated() {
        if (this.$route.path.includes('/en_NZ/resources')) {
            setTimeout(function () {
                // Removes styling bugs
                var fixedPosition = $('.fixed-position');
                fixedPosition.removeAttr('style');
                var advanceSearch = fixedPosition.find('.advance-search');
                advanceSearch.removeAttr('style').css({
                    'position': 'fixed',
                    'width': '100%'
                });
                fixedPosition.find('.js-steps-section').height('500px');
                // filter bar is fixed which hides the selected filters, so move the main content down so everything is visible
                var main = $('.js-main');
                main.css('top', advanceSearch.height());
                // once the user scrolls the original styling is applied to the header section, so remove the top position styling from the main content
                $(window).one('scroll', function () {
                    main.css('top', '0');
                });
            }, 5);
            initStickyScrollBlock();
        }
    }
});
